import React from 'react'
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const TabPanel = (props) => {
    const { children,padding,backgroundColor, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
            overflow="auto"
        >
            {value === index && (
                // <Box sx={{ p: 1, backgroundColor: "red" }}>
                 <Box sx={{padding:padding?? 1, backgroundColor: backgroundColor??"#e5e8f2", minHeight: "90vh", overflow:"auto"}}> 
                    <Box className="inner-tab-box">{children}</Box>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export default TabPanel